module.exports = __webpack_public_path__ + "static/p08_cerdoGrande-ca371f7d80d1a75d69c3dcef1e7a15dc.png";